
import { defineComponent, PropType } from 'vue'
import { useThemeModel } from '@entities/theme'

export default defineComponent({
  name: 'AlertScanSuccess',
  props: {
    successfulScan: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    }
  },

  setup () {
    const themeModel = useThemeModel()

    return {
      themeModel
    }
  }
})
